export * from './tips.component';
